import AlgoliaData from '@module/Algolia/resources/js/search/interfaces/AlgoliaData';
import ProductData from '../interfaces/ProductData';
import StoreData from '../interfaces/StoreData';
import { getData, getImage } from '@module/Algolia/resources/js/search/helpers';
import {
  transformProduct as baseTransformProduct,
  transformStore as baseTransformStore,
} from '@module/Algolia/resources/js/search/transformers';

export const transformProduct = (data: AlgoliaData): ProductData => {
  const base = baseTransformProduct(data);

  const labelId = (getData(data.labels, []) as string[])?.shift();

  return {
    ...base,
    hoverImage: getImage(getData(data.imageCardHover), base.name),
    description: getData(data.subtitle, ''),
    itemId: `product-page-${getData(data.pageId, '')}`,
    label: labelId ? window.Phoenix.i18n.t(labelId) : undefined,
  };
};

export const transformStore = (data: AlgoliaData): StoreData => ({
  ...baseTransformStore(data, [1, 2, 3, 4]),
  productCategories: (getData(data.productCategories, []) as string[]).map((item) => ({
    title: window.Phoenix.i18n.t(`MainNavigation.${item}`),
    icon: item.replace('_', '-'),
  })),
  specialDays: getData(data.openingHoursExceptions, [], false),
});
